export const userTypesList = {
  ANONYMOUS: 'Anonymous',
  REGISTERED: 'Registered',
  SUBSCRIBER: 'Subscriber',
  SFOGLIATORE: 'Sfogliatore',
};
